import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

import logo from './assets/logo_antoo.png';
import tiktokLogo from './assets/tik-tok.png';
import instagramLogo from './assets/instagram.png';
import linkedinLogo from './assets/linkedin.png';
import incubateurLogo from './assets/incub_logo.jpg';
import downArrow from './assets/fleche-bas.png';
import epitechLogo from './assets/Epitech-logo.png';
import neomaLogo from './assets/Neoma-logo.png';
import CYUniversityLogo from './assets/CY-uni-logo.png';
import AboutUsStats from './assets/section-about-stats.png';
import SolutionImage from './assets/appercu-produit.png';
import SachaImage from './assets/sacha.jpg';
import BenjiImage from './assets/benji.jpg';
import MaxenceImage from './assets/maxence.jpeg';
import menuIcon from './assets/menu-burger.png';

import styles from './Privacy.module.css';

const Step = ({ number, active }) => {
  return (
    <div className={`${styles.step} ${active ? styles.active : ''}`}>
      <div className={styles.circle}>{number}</div>
    </div>
  );
};

const ProgressBar = ({ steps }) => {
  return (
    <div className={styles['progress-bar']}>
      {steps.map((step, index) => (
        <div key={index} className={`${styles.step} ${step.active ? styles.active : ''}`}>
          <div className={styles.circle}>{index + 1}</div>
          <div className={styles['step-text']}>{step.text}</div>
        </div>
      ))}
    </div>
  );
};

function Privacy() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleButtonClick = () => {
    window.location.href = '/join-us';
  };

  const steps = [
    { text: 'Birth of Antoo', description: "The birth lol", active: true },
    { text: 'Establishment of strategic partnerships', description: "The birth lol", active: true },
    { text: 'Official launch of the application', description: "The birth lol", active: false },
    { text: 'Communication campaign', description: "The birth lol", active: false },
    { text: 'Continuous improvement', description: "The birth lol", active: false },
    { text: 'International expansion', description: "The birth lol", active: false },
  ];

  return (
    <div className={styles.App}>
      <Helmet>
      <title>Antoo - Find the ideal partner for your projects</title>
      <meta name="description" content="Avec Antoo, trouvez le partenaire idéal pour transformer vos idées en succès." />
      <meta name="keywords" content="Matching entrepreneurial, Trouver un associé startup, Plateforme pour entrepreneurs, Réseau entrepreneurial, Partenariat startup, Application pour entrepreneurs, Communauté d’entrepreneurs, Association d’entrepreneurs, Création de startup, Collaborateur startup, Networking startup, Recherche co-fondateur, Collaboration entrepreneuriale, Mentor startup, Équipe fondatrice, Levée de fonds startup, Écosystème entrepreneurial, Événements pour entrepreneurs, Gestion de projet startup, Entrepreneuriat digital, Comment trouver un associé pour ma startup, Plateforme de mise en relation pour entrepreneurs, Créer une équipe startup performante, Outils pour startups en phase de lancement, Réseau d’entrepreneurs pour jeunes créateurs, App de matching pour entrepreneurs, Application pour trouver des partenaires business, Innovation entrepreneuriale, Algorithme de matching startup, Solutions innovantes pour startups, Nouveaux modèles d’entrepreneuriat, Startups disruptives, Entrepreneuriat en France, Startup Paris, Écosystème startup européen, Entrepreneurial matching, Find a startup partner, Platform for entrepreneurs, Entrepreneurial network, Startup partnership, App for entrepreneurs, Entrepreneur community, Entrepreneur association, Startup creation, Startup collaborator, Startup networking, Co-founder search, Entrepreneurial collaboration, Startup mentor, Founding team, Startup fundraising, Entrepreneurial ecosystem, Events for entrepreneurs, Startup project management, Digital entrepreneurship, How to find a partner for my startup, Networking platform for entrepreneurs, Create a high-performing startup team, Tools for launching startups, Entrepreneur network for young creators, Matching app for entrepreneurs, App to find business partners, Entrepreneurial innovation, Startup matching algorithm, Innovative solutions for startups, New entrepreneurship models, Disruptive startups, Entrepreneurship in France, Startup Paris, European startup ecosystem" />
      <meta property="og:title" content="Antoo - Trouvez le partenaire idéal pour vos projets" />
      <meta property="og:description" content="Avec Antoo, trouvez le partenaire idéal pour transformer vos idées en succès." />
      <meta property="og:image" content={logo} />
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-W5VJLLV5');`}
        </script>
      </Helmet>
      <main>
        <section className={styles.privacySection}>
          <h1>Privacy Policy</h1>
          <p>
            At Antoo, we value your privacy and are committed to protecting your personal data. This privacy policy outlines how we collect, use, and store your information.
          </p>
          <h2>Data Collection</h2>
          <p>
            We collect personal data that you provide to us directly, such as when you create an account, fill out a form, or contact us. This may include your name, email address, and other contact information.
          </p>
          <h2>Data Usage</h2>
          <p>
            The data we collect is used to provide and improve our services, communicate with you, and ensure the security of our platform. We do not sell or share your personal data with third parties without your consent.
          </p>
          <h2>Data Hosting</h2>
          <p>
            Your data is securely hosted on servers located in the European Union. We implement appropriate technical and organizational measures to protect your data from unauthorized access, loss, or misuse.
          </p>
          <h2>Types of Data Collected</h2>
          <p>
            The following data may be collected and linked to your identity:
          </p>
          <ul>
            <li>Contact Information</li>
            <li>User Content</li>
            <li>Identifiers</li>
            <li>Other Data</li>
          </ul>
          <h3>Details of Data Collected</h3>
          <ul>
            <li>
              <strong>Name:</strong> Used for app functionality, linked to user identity.
            </li>
            <li>
              <strong>Email Address:</strong> Used for app functionality, linked to user identity.
            </li>
            <li>
              <strong>User Content (Photos or Videos):</strong> Used for app functionality, linked to user identity.
            </li>
            <li>
              <strong>User Identifier:</strong> Used for app functionality, linked to user identity.
            </li>
            <li>
              <strong>Other Data:</strong> Used for app functionality, linked to user identity.
            </li>
          </ul>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about our privacy policy or if you wish to delete your personal data, please contact us at <a href="mailto:privacy@antoo.com">privacy@antoo.com</a>.
          </p>
        </section>
      </main>
      <footer className={styles['App-footer']}>
        <p>&copy; {new Date().getFullYear()} Antoo. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Privacy;